import { buildInteractorDirectAction, buildInteractorDirectActionNoParams } from './base';
import { nordicFormActions } from '../slices/nordicFormSlice';

export const updateFirstCheckInteractor = buildInteractorDirectAction(nordicFormActions.updateFirstCheck);
export const updateWeekCheckInteractor = buildInteractorDirectAction(nordicFormActions.updateWeekCheck);
export const updateWeekScaleInteractor = buildInteractorDirectAction(nordicFormActions.updateWeekScale);
export const updatePartDetailsInteractor = buildInteractorDirectAction(nordicFormActions.updatePartDetails);
export const resetNordicFormInteractor = buildInteractorDirectActionNoParams(nordicFormActions.resetNordicForm);
